;(() => {
  if (customElements.get("recharge-widget")) return

  const formsFor = (widget) => {
    const productId = widget.dataset.productId
    const byClass = document.querySelectorAll(`form.product-${productId}`)
    if (byClass.length) return byClass

    const scope = widget.closest(".product__info-container")
    if (!scope) return []
    return scope.querySelectorAll('form[data-type="add-to-cart-form"]')
  }

  const quantityInput = (widget) => {
    const scope =
      widget.closest(".product__info-container") ||
      widget.closest("[data-product-id]")
    return scope?.querySelector("quantity-input input, .quantity__input")
  }

  customElements.define(
    "recharge-widget",
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return
        this.dataset.bound = "true"

        const onetime = this.querySelector(".recharge-onetime")
        const subscribe = this.querySelector(".recharge-subscribe")
        const select = this.querySelector("select")
        const onetimeRadio = this.querySelector('[data-purchase="onetime"]')
        const subscribeRadio = this.querySelector('[data-purchase="subscribe"]')
        const maxQuantity = Number(this.dataset.maxQuantity || 0)
        const qty = quantityInput(this)

        const setSellingPlan = (value) => {
          formsFor(this).forEach((form) => {
            let input = form.querySelector('input[name="selling_plan"]')
            if (!input) {
              input = document.createElement("input")
              input.type = "hidden"
              input.name = "selling_plan"
              input.className = "recharge-input"
              form.appendChild(input)
            }
            if (value) {
              input.disabled = false
              input.value = value
            } else {
              input.value = ""
              input.disabled = true
            }
          })
        }

        const clampQuantity = () => {
          if (!maxQuantity || !qty) return
          if (Number(qty.value) > maxQuantity) qty.value = String(maxQuantity)
        }

        const selectOnetime = () => {
          subscribe.classList.remove("active")
          onetime.classList.add("active")
          if (onetimeRadio) onetimeRadio.checked = true
          setSellingPlan("")
        }

        const selectSubscribe = () => {
          onetime.classList.remove("active")
          subscribe.classList.add("active")
          if (subscribeRadio) subscribeRadio.checked = true
          setSellingPlan(select?.value || "")
          clampQuantity()
        }

        onetime?.addEventListener("click", selectOnetime)
        subscribe?.addEventListener("click", (event) => {
          if (event.target.closest("select")) return
          selectSubscribe()
        })
        select?.addEventListener("click", (event) => event.stopPropagation())
        select?.addEventListener("change", () => {
          if (subscribe.classList.contains("active")) {
            setSellingPlan(select.value)
          }
        })
        onetimeRadio?.addEventListener("change", () => {
          if (onetimeRadio.checked) selectOnetime()
        })
        subscribeRadio?.addEventListener("change", () => {
          if (subscribeRadio.checked) selectSubscribe()
        })

        if (maxQuantity && qty) {
          qty.addEventListener("change", () => {
            if (subscribe.classList.contains("active")) clampQuantity()
          })
        }

        if (subscribe?.classList.contains("active")) {
          if (select && subscribeRadio?.value) select.value = subscribeRadio.value
          selectSubscribe()
        } else {
          selectOnetime()
        }
      }
    },
  )
})()
